import MockDrawer from './mock_drawer';

describe('MockDrawer', () => {
  it('should return that it is not in a drawer', () => {
    const mockDrawer = new MockDrawer();

    expect(mockDrawer.sideDrawer.elementIsInDrawer(null)).toBe(false);
  });
});
